/**
 * NOTICE OF LICENSE.
 *
 * This source file is subject to a commercial license from SASU WEB FUSION AGENCY
 * Use, copy, modification or distribution of this source file without written
 * license agreement from the SASU WEB FUSION AGENCY is strictly forbidden.
 * In order to obtain a license, please contact us: contact@web-fusion.fr
 *
 * @author SASU WEB FUSION AGENCY
 * @copyright Copyright (c) 2024 - SASU WEB FUSION AGENCY
 * @license   Commercial license
 *
 * @version 1.6.0
 */

import './front.scss';
import './components/calendar.scss';
import './components/oracle.scss';
import './components/treasure';
import './components/calendar_front';
import './components/oracle';
import SweetAlert from 'sweetalert2';

$(document).ready(function () {
  if ($('#scratch-text').length === 0) {
    return;
  }

  var $canvas = $('#scratchCanvas');
  var $image = $('#scratch-image');
  var ctx = $canvas[0].getContext('2d');
  var isScratching = false;
  var scratchThresholdReached = false;
  var revealThreshold = 60;
  var currentScratchArea = null;
  var scratchBrushSize = 22;

  var $scratchCoordinates = $('#scratch-coordinates');
  var scratchArea = {
    x: parseFloat($scratchCoordinates.data('x')),
    y: parseFloat($scratchCoordinates.data('y')),
    width: parseFloat($scratchCoordinates.data('width')),
    height: parseFloat($scratchCoordinates.data('height'))
  };

  var $scratchText = $('#scratch-text');
  var $progress = $('.wfa-scratch-progress');
  var $progressBar = $('.wfa-scratch-progress__bar');
  var $progressValue = $('#scratch-progress-value');
  var $revealButton = $('.wfa-scratch-reveal');

  function isValidScratchArea(area) {
    return area &&
      Number.isFinite(area.x) &&
      Number.isFinite(area.y) &&
      Number.isFinite(area.width) &&
      Number.isFinite(area.height) &&
      area.width > 0 &&
      area.height > 0;
  }

  function getScaledScratchArea() {
    var naturalWidth = $image[0].naturalWidth || $image.width();
    var naturalHeight = $image[0].naturalHeight || $image.height();
    var scaleX = naturalWidth > 0 ? $image.width() / naturalWidth : 1;
    var scaleY = naturalHeight > 0 ? $image.height() / naturalHeight : 1;

    if (!isValidScratchArea(scratchArea)) {
      return {
        x: $image.width() * 0.16,
        y: $image.height() * 0.36,
        width: $image.width() * 0.68,
        height: $image.height() * 0.28
      };
    }

    return {
      x: scratchArea.x * scaleX,
      y: scratchArea.y * scaleY,
      width: scratchArea.width * scaleX,
      height: scratchArea.height * scaleY
    };
  }

  function clampScratchArea(area) {
    var canvasWidth = $canvas[0].width;
    var canvasHeight = $canvas[0].height;

    area.x = Math.max(0, Math.min(area.x, canvasWidth));
    area.y = Math.max(0, Math.min(area.y, canvasHeight));
    area.width = Math.max(1, Math.min(area.width, canvasWidth - area.x));
    area.height = Math.max(1, Math.min(area.height, canvasHeight - area.y));

    return area;
  }

  function resizeScratchArea() {
    if (!$image.width() || !$image.height()) {
      return;
    }

    $canvas[0].width = $image.width();
    $canvas[0].height = $image.height();
    $canvas.css({
      top: $image.position().top,
      left: $image.position().left
    });

    currentScratchArea = clampScratchArea(getScaledScratchArea());

    $scratchText.css({
      top: currentScratchArea.y + 'px',
      left: currentScratchArea.x + 'px',
      width: currentScratchArea.width + 'px',
      height: currentScratchArea.height + 'px',
    });

    ctx.clearRect(0, 0, $canvas[0].width, $canvas[0].height);
    ctx.globalCompositeOperation = 'source-over';
    ctx.fillStyle = typeof bg_scraping !== 'undefined' && bg_scraping ? bg_scraping : '#cfd6dd';
    ctx.fillRect(currentScratchArea.x, currentScratchArea.y, currentScratchArea.width, currentScratchArea.height);

    drawScratchTexture(currentScratchArea);
  }

  $image.on('load', function() {
    resizeScratchArea();
  }).each(function() {
    if (this.complete) $(this).trigger('load');
  });

  $(window).resize(resizeScratchArea);

  function drawScratchTexture(area) {
    ctx.save();
    ctx.globalCompositeOperation = 'source-atop';
    ctx.strokeStyle = 'rgba(255, 255, 255, 0.28)';
    ctx.lineWidth = 2;

    for (var i = -area.height; i < area.width; i += 22) {
      ctx.beginPath();
      ctx.moveTo(area.x + i, area.y + area.height);
      ctx.lineTo(area.x + i + area.height, area.y);
      ctx.stroke();
    }

    ctx.fillStyle = 'rgba(255, 255, 255, 0.62)';
    ctx.font = '600 14px Arial, sans-serif';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText('GRATTEZ ICI', area.x + area.width / 2, area.y + area.height / 2);
    ctx.restore();
  }

  function scratch(x, y) {
    if (!currentScratchArea) {
      return;
    }

    ctx.globalCompositeOperation = 'destination-out';
    ctx.beginPath();
    ctx.arc(x, y, scratchBrushSize, 0, Math.PI * 2, true);
    ctx.fill();
  }

  function setProgress(percentageScratched) {
    var roundedPercentage = Math.max(0, Math.min(100, Math.round(percentageScratched)));
    $progress.attr('aria-valuenow', roundedPercentage);
    $progressBar.css('width', roundedPercentage + '%');
    $progressValue.text(roundedPercentage);
  }

  function revealResult() {
    if (scratchThresholdReached || !currentScratchArea) {
      return;
    }

    scratchThresholdReached = true;
    ctx.clearRect(currentScratchArea.x, currentScratchArea.y, currentScratchArea.width, currentScratchArea.height);
    setProgress(100);

    var win = $scratchText.data('win');
    $scratchText
      .addClass(win ? 'is-winner' : 'is-loser')
      .css('color', win ? '#147a42' : '#9a1c1c');

    $.post(typeof url_scratch_validation !== 'undefined' ? url_scratch_validation : '', {
      action: 'scratch',
      win: win,
      id: $scratchText.data('id_instant_customer'),
      id_instant: $scratchText.data('id_instant')
    }, null, 'json')
      .then(function (resp) {
        setTimeout(function() {
          SweetAlert.fire({
            html: resp.html,
            width: 600,
            confirmButtonColor: resp.color_button
          });
        }, 700);
      });
  }

  function checkScratchCompletion() {
    if (!currentScratchArea || scratchThresholdReached) {
      return;
    }

    var imageData = ctx.getImageData(
      Math.round(currentScratchArea.x),
      Math.round(currentScratchArea.y),
      Math.max(1, Math.round(currentScratchArea.width)),
      Math.max(1, Math.round(currentScratchArea.height))
    );

    var totalPixels = imageData.data.length / 4;
    var scratchedPixels = 0;

    for (var i = 0; i < imageData.data.length; i += 4) {
      if (imageData.data[i + 3] === 0) {
        scratchedPixels++;
      }
    }

    var percentageScratched = (scratchedPixels / totalPixels) * 100;
    setProgress(percentageScratched);

    if (percentageScratched >= revealThreshold) {
      revealResult();
    }
  }

  // Pour mobile
  $canvas.on('mousedown touchstart', function (e) {
    isScratching = true;
    var pos = getPosition(e);
    scratch(pos.x, pos.y);
  });
  $canvas.on('mousemove touchmove', function (e) {
    if (!isScratching) return;
    e.preventDefault();
    var pos = getPosition(e);
    scratch(pos.x, pos.y);

    if (!scratchThresholdReached) {
      checkScratchCompletion();
    }
  });

  $canvas.on('mouseup touchend', function () {
    isScratching = false;
  });

  // Pour desktop
  $canvas.on('mousedown', function (e) {
    isScratching = true;
    scratchAtEvent(e);
  });

  $canvas.on('mouseup', function () {
    isScratching = false;
    checkScratchCompletion();
  });

  $canvas.on('mousemove', function (e) {
    if (isScratching) {
      scratchAtEvent(e);
    }
  });

  $canvas.on('touchstart', function (e) {
    e.preventDefault();
    isScratching = true;
    scratchAtTouch(e);
  });

  $canvas.on('touchend', function () {
    isScratching = false;
    checkScratchCompletion();
  });

  $canvas.on('touchmove', function (e) {
    e.preventDefault();
    if (isScratching) {
      scratchAtTouch(e);
    }
  });

  function getPosition(e) {
    var offset = $canvas.offset();
    var x, y;

    if (e.type.startsWith('touch')) {
      var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
      x = touch.pageX - offset.left;
      y = touch.pageY - offset.top;
    } else {
      x = e.pageX - offset.left;
      y = e.pageY - offset.top;
    }

    return { x: x, y: y };
  }

  function scratchAtEvent(e) {
    var rect = $canvas[0].getBoundingClientRect();
    var mouseX = e.clientX - rect.left;
    var mouseY = e.clientY - rect.top;

    if (currentScratchArea &&
      mouseX > currentScratchArea.x && mouseX < currentScratchArea.x + currentScratchArea.width &&
      mouseY > currentScratchArea.y && mouseY < currentScratchArea.y + currentScratchArea.height) {
      scratch(mouseX, mouseY);
    }
  }

  function scratchAtTouch(e) {
    var rect = $canvas[0].getBoundingClientRect();
    var touch = e.touches[0];
    var touchX = touch.clientX - rect.left;
    var touchY = touch.clientY - rect.top;

    if (currentScratchArea &&
      touchX > currentScratchArea.x && touchX < currentScratchArea.x + currentScratchArea.width &&
      touchY > currentScratchArea.y && touchY < currentScratchArea.y + currentScratchArea.height) {
      scratch(touchX, touchY);
    }
  }

  $revealButton.on('click', revealResult);

  function copyToClipboard() {
    var code = $(this).text();
    navigator.clipboard.writeText(code).then(function() {
      SweetAlert.fire({
        icon: 'success',
        title: 'Copied!',
        text: 'Promo code copied to clipboard!',
        timer: 1500,
        showConfirmButton: false
      });
    }, function(err) {
      console.error('Could not copy text: ', err);
    });
  }

  $(document).on('click', '.copy', copyToClipboard);
});

$(document).ready(function() {
  $('#quiz-form').on('submit', function(e) {
    let erreurs = [];
    $('.answers').each(function() {
      const $answers = $(this);
      const isMultiple = $answers.find('input').first().attr('type') === 'checkbox';
      const message = "Veuillez sélectionner au moins une réponse.";

      let isChecked = $answers.find('input:checked').length > 0;

      if (!isChecked) {
        SweetAlert.fire({
          position: "top-end",
          icon: "error",
          title: message,
          showConfirmButton: false,
          timer: 1500
        });
        erreurs.push(message);
      }
    });

    if (erreurs.length > 0) {
      e.preventDefault();
      return false;
    }
  });

  $('.answers').on('click', 'li', function() {
    const $li = $(this);
    const $input = $li.find('input');
    const $answers = $li.closest('.answers');
    const isMultiple = $input.is(':checkbox');

    if ($input.length) {
      if (isMultiple) {
        $li.toggleClass('selected');
        $input.prop('checked', !$input.prop('checked')).trigger('change');
      } else {
        $answers.find('li').removeClass('selected');
        $li.addClass('selected');
        $input.prop('checked', true).trigger('change');
      }
    }
  });
});
